import * as React from 'react';
import './SelectWithLabel.scss';

interface Props {
  className: string;
  classNamePrefix: string;
  value: any;
  onChange: (value: any) => void;
  options: any;
  placeholder: string;
  zIndex?: number;
  error?: boolean;
  mandatory?: boolean;
  id: string;
}
interface State {
  currentValue: string;
}
export default class SelectWithLabel extends React.Component<Props> {
  state: State = {
    currentValue: this.props.value
  };

  handleChange = (event: any) => {
    this.setState({ currentValue: event.target.value });
    const matchedOptions = this.props.options.filter((v:any) => v.value === event.target.value);
    this.props.onChange(matchedOptions.length === 0 || matchedOptions[0].value === null ? null : matchedOptions[0]);
  };

  public render() {
    return (
      <div
        className={
          'select-with-label' +
          (this.props.error ? ' error' : '')
        }
      >
        <label htmlFor={this.props.id} className={`${this.props.classNamePrefix}-label`}>
          {this.props.placeholder}
          {this.props.mandatory && <em className="text-red"> *</em>}
        </label>
        <select
          className={this.props.className}
          onChange={this.handleChange}
          id={this.props.id}
          defaultValue=""
        >
          <option value="" disabled>Sélectionnez une valeur</option>
          {this.props.options.map((option:any) => (
              <option key={option.value} value={option.value} className={`${this.props.classNamePrefix}-option`}>{option.label}</option>
          ))}
        </select>
      </div>
    );
  }
}
